var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialog)?_c('common-details-dialog',{attrs:{"title":'Informazioni fornitore: ' + _vm.value && _vm.value.businessName,"data-to-show":_vm.dataToShow},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }